/*************************************************
 * Menu logic
 *************************************************/
//var State = require('./state.js');

$(document).ready(function () {
    //active parent menu
    (function () {
        var element = $('main div[data-parentmenu]');
        if (element && element.length > 0) {
            var activeMenu = element.data('parentmenu');
            $(activeMenu).addClass('active');
        }
    })();

    //add animation to second level menu
    (function () {
        $('header .nav-link').on('show.bs.dropdown', function () {
            $(this).parent().find('.dropdown-menu').first().slideDown();
        });

        $('header .main-nav .nav-link').on('hide.bs.dropdown', function () {
            if ($(window).width() >= 768) {
                $(this).parent().find('.dropdown-menu').first().slideUp(100);
            } else {
                $(this).parent().find('.dropdown-menu').first().slideUp();
            }
        });

        $('header .side-nav .nav-link').on('hide.bs.dropdown', function () {
            $(this).parent().find('.dropdown-menu').first().slideUp(100);
        });
    })();

    (function() {
        let status = {};
        status.isActive = false;
        
        let mobileMenuBtn = document.body.querySelector('.navbar-toggler');
        let mobileCloseMenuBtn = document.body.querySelector('.close-mobile-menu');
        let mainNav = document.body.querySelector('.main-nav');

        function changeActiveStates() {
            status.isActive = !status.isActive;

            if (status.isActive) {
                $('body, html').css('height', '100%');
                mainNav.classList.add('is-active');
            } else {
                $('body, html').css('height', '');
                mainNav.classList.remove('is-active');
            }
        }

        if (mobileMenuBtn && mobileCloseMenuBtn) {
            mobileMenuBtn.addEventListener('click', changeActiveStates);
            mobileCloseMenuBtn.addEventListener('click', function() {
                mobileMenuBtn.click();
            });
        }
    })();

    //menu active on mobile
    /*
    (function () {
        function changeActiveStates() {
            s.isActive = !s.isActive;

            if (s.isActive) {
                $('body, html').css('height', '100%');
            } else {
                $('body, html').css('height', '');
            }
        }

        var wholePageWrapper = document.body.querySelector('.whole-page-wrapper');
        var mobileMenuBtn = document.body.querySelector('a[href="#/mobile-menu"]');
        var mobileCloseMenuBtn = document.body.querySelector('.close-mobile-menu');
        var mobileMenuList = document.body.querySelector('.nav-region.main-nav');

        if (mobileMenuBtn && mobileCloseMenuBtn) {
            var s = Object.create(State);
            s.init(null, 'menu-is-active');

            s.addElement(wholePageWrapper);
            s.addElement(mobileMenuList);
            s.addElement(mobileMenuBtn);

            mobileCloseMenuBtn.addEventListener('click', changeActiveStates);
            mobileMenuBtn.addEventListener('click', changeActiveStates);

            window.addEventListener('resize', function () {
                if (window.innerWidth > 768) {
                    s.isActive = false;
                }
            });
        }
    })();
    */
});